const BASE = 36
const START = 2
const LENGTH = 9

export const generateSimpleUniqueId = () =>
  `id-${Math.random().toString(BASE).slice(START, LENGTH)}`
